// Role + content-scope definitions for the UI. This MIRRORS the backend
// (backend/app/core/permissions.py). The backend is the authoritative gate;
// these client-side helpers only decide what to show/offer. Keep the two in sync.

// All job positions, in display order, with their labels and department.
export const POSITIONS = [
  { value: 'office', label: 'Office', department: 'office' },
  { value: 'cleaner', label: 'Cleaner', department: 'office' },
  { value: 'receptionist', label: 'Receptionist', department: 'reception' },
  { value: 'rvn', label: 'RVN Nurse', department: 'nurses' },
  { value: 'rvn_night_nurse', label: 'RVN Night Nurse', department: 'nurses' },
  { value: 'student_nurse', label: 'Student Nurse', department: 'nurses' },
  { value: 'trainee_nurse', label: 'Trainee Nurse', department: 'nurses' },
  { value: 'veterinary_surgeon', label: 'Veterinary Surgeon', department: 'vets' },
  { value: 'ooh_veterinary_surgeon', label: 'Veterinary Surgeon OOH', department: 'vets' },
  { value: 'zero_hours_vet', label: 'Zero Hours Vet', department: 'vets' },
];

// Roles, in display order, with label and the departments they can access.
// `departments: null` means all departments (no restriction).
export const ROLES = [
  { value: 'admin', label: 'Admin', departments: null },
  { value: 'director', label: 'Director', departments: null },
  { value: 'head_of_hr', label: 'Head of HR', departments: null },
  { value: 'practice_manager', label: 'Practice Manager', departments: null },
  { value: 'wellness_manager', label: 'Wellness Manager', departments: null },
  { value: 'head_vet', label: 'Head Vet', departments: ['vets'] },
  { value: 'deputy_head_vet', label: 'Deputy Head Vet', departments: ['vets'] },
  { value: 'head_nurse', label: 'Head Nurse', departments: ['nurses'] },
  { value: 'deputy_head_nurse', label: 'Deputy Head Nurse', departments: ['nurses'] },
  { value: 'head_receptionist', label: 'Head Receptionist', departments: ['reception'] },
];

// The department a position belongs to ('vets' | 'nurses' | 'reception' |
// 'office'), mirroring POSITION_DEPARTMENT in core/permissions.py. The Interview
// pane uses it to pick each team's steps (reception has a phone interview and a
// 3-hour trial shift; vets and nurses a full trial day).
export function departmentForPosition(positionValue) {
  const position = POSITIONS.find((p) => p.value === positionValue);
  return position ? position.department : null;
}

export function roleLabel(roleValue) {
  const role = ROLES.find((r) => r.value === roleValue);
  return role ? role.label : '—';
}

// True only for all-access roles (can see every candidate). Gates the
// Templates & Folders page. Mirrors user_has_full_candidate_access() on the
// backend, which is the authoritative gate.
export function hasFullAccess(roleValue) {
  const role = ROLES.find((r) => r.value === roleValue);
  return !!role && role.departments === null;
}

// Positions a given role may access. Returns the full list for all-access roles.
// An unknown/empty role returns [] (fail closed, matching the backend).
export function positionsForRole(roleValue) {
  const role = ROLES.find((r) => r.value === roleValue);
  if (!role) return [];
  if (role.departments === null) return POSITIONS;
  return POSITIONS.filter((p) => role.departments.includes(p.department));
}
